import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import Container from '../../General/Container';
import Accordion from './Accordion';
import Empty from './Empty';
import { Title, FlexLane } from './styles/MonthlyInvoicesStyled';
import Divider from '../../General/Divider';
import Button from '../../General/Button';
import { RefreshIcon } from '../../../images/mis-boletas';

const MonthlyInvoices = ({
  data,
  elementRef,
  loadFunc,
  inView,
  selectedAccount,
}) => {
  const [invoicesData, setInvoicesData] = useState(null);
  const isMedium = useMediaQuery({
    query: '(min-width: 768px)',
  });
  useEffect(() => {
    if (data?.lastSemester !== null && data?.lastInvoice !== null) {
      const invoices = data.lastSemester.slice();
      invoices.unshift(data.lastInvoice);
      setInvoicesData(invoices);
    }
  }, [data]);

  return (
    <motion.div
      ref={elementRef}
      animate={inView ? 'open' : 'closed'}
      variants={{
        closed: { opacity: 0, y: 20 },
        open: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.5 }}
    >
      {inView && (
        <>
          <Container
            background="#fff"
            boxShadow="0px 2px 4px rgba(45, 20, 65, 0.15)"
          >
            <FlexLane>
              <Title>Boletas telefonía móvil</Title>
              <Button
                margin="0"
                outline
                color="purple"
                height="35px"
                width="155px"
                click={loadFunc}
              >
                <RefreshIcon style={{ marginRight: '10px' }} />
                <span>Actualizar</span>
              </Button>
            </FlexLane>
            {isMedium ? (
              <Divider lineStyle="solid" color="#d4c6c6" width="100%" />
            ) : (
              <></>
            )}

            {invoicesData ? (
              <Accordion
                data={invoicesData}
                selectedAccount={selectedAccount}
              />
            ) : (
              <Empty />
            )}
          </Container>
        </>
      )}
    </motion.div>
  );
};

MonthlyInvoices.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  inView: PropTypes.bool.isRequired,
  elementRef: PropTypes.instanceOf(Object).isRequired,
  loadFunc: PropTypes.func.isRequired,
  selectedAccount: PropTypes.string.isRequired,
};

export default MonthlyInvoices;
